import { render, staticRenderFns } from "./PreferenceTruck.vue?vue&type=template&id=c98525c0&"
import script from "./PreferenceTruck.vue?vue&type=script&lang=ts&"
export * from "./PreferenceTruck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98525c0')) {
      api.createRecord('c98525c0', component.options)
    } else {
      api.reload('c98525c0', component.options)
    }
    module.hot.accept("./PreferenceTruck.vue?vue&type=template&id=c98525c0&", function () {
      api.rerender('c98525c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceTruck.vue"
export default component.exports